module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.products), function(product) {
    return _c('div', {
      staticClass: "mb-2"
    }, [_c('div', {
      staticClass: "productRow d-flex align-items-center pointer",
      class: {
        'selected': _vm.isThisProductSelected(product)
      },
      on: {
        "click": function($event) {
          return _vm.blacklistProduct(product)
        }
      }
    }, [_c('div', {
      staticClass: "square mr-2",
      style: ({
        'background-color': _vm.selectProductColor(product).areaBackground,
        'border-color': _vm.selectProductColor(product).areaBorder
      })
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(product.name))])])])
  }), 0)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-5cab5152", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cab5152"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/filters/productFilterV2.vue
// module id = 1688
// module chunks = 0